<app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
<div class="my-3 flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">
  <h2>Accident Record - {{ record?.refNo }}</h2>
  <button *appHasAnyPrivilege="'REPORT_GENERATE'" nz-button nzType="primary" (click)="setEditDescription()">Generate
    Report
  </button>
</div>

<div [ngClass]="!loading ? 'block' : 'hidden'">
  <section id="vehicleAndBookingDetails">
    <div class="grid xl:grid-cols-2 gap-4">
      <nz-card>
        <h5 class="mb-3">Vehicle Details</h5>
        <div class="sub-section">
          <div class="item-row">
            <p class="subject-name">Model</p>
            <p class="subject-data">{{ record?.fleet?.vehicleDetails?.vehicleModel }}</p>
          </div>
          <div class="item-row">
            <p class="subject-name">Registration Number </p>
            <p class="subject-data">{{ record?.fleet?.vehicleDetails?.registrationNumber }}</p>
          </div>
        </div>
      </nz-card>
      <nz-card>
        <h5 *ngIf="record?.accidentType === 'BOOKING'" class="mb-3">Booking Details</h5>
        <div *ngIf="record?.accidentType === 'BOOKING'" class="sub-section">
          <div class="item-row">
            <p class="subject-name">SR Booking Id </p>
            <a *ngIf="selectedBooking?.refNo" (click)="goTo('booking')"><p
              class="subject-data">{{ selectedBooking.refNo }}</p></a>
            <p *ngIf="!selectedBooking?.refNo" class="subject-data">-</p>
          </div>
          <div class="item-row">
            <p class="subject-name">Customer Name </p>
            <a *ngIf="selectedBooking?.customerName" (click)="goTo('customer')"><p
              class="subject-data">{{ selectedBooking.customerName }}</p></a>
            <p *ngIf="!selectedBooking?.customerName" class="subject-data">-</p>
          </div>
          <div class="item-row">
            <p class="subject-name">Agent Name </p>
            <p *ngIf="selectedBooking?.agentName" class="subject-data">{{ selectedBooking?.agentName }}</p>
            <p *ngIf="!selectedBooking?.agentName" class="subject-data">-</p>
          </div>
          <div class="item-row">
            <p class="subject-name">Agent Reference No </p>
            <p class="subject-data">{{ selectedBooking?.agentRefNo ? selectedBooking?.agentRefNo : '-' }}</p>
          </div>
          <div class="item-row">
            <p class="subject-name">Booking Type </p>
            <p class="subject-data">{{ selectedBooking?.type ? selectedBooking?.type : '-' }}</p>
          </div>
        </div>

        <div *ngIf="!(record?.accidentType === 'BOOKING')" class="sub-section">
          <div class="item-row">
            <p class="subject-name">Reason </p>
            <p class="subject-data">{{ record?.reason }}</p>
          </div>
        </div>
      </nz-card>
    </div>
  </section>

  <section id="insuranceDetails">
    <nz-card class="mt-5">
      <h5 class="mb-3">Insurance Details</h5>
      <div class="grid gap-x-4 md:gap-x-16 xl:grid-cols-2">
        <div class="sub-section">
          <div class="item-row">
            <p class="subject-name">Insurance Company </p>
            <p class="subject-data">{{ record?.fleet?.otherDetails?.insuranceName }}</p>
          </div>
        </div>
        <div class="sub-section">
          <div class="item-row">
            <p class="subject-name">Third Party Vehicle Reg Number </p>
            <p
              class="subject-data">{{ record?.insuranceDetails?.thirdPartyVehicleRegisterNo ? record?.insuranceDetails?.thirdPartyVehicleRegisterNo : '-' }}</p>
          </div>
          <div class="item-row">
            <p class="subject-name">Third Party Driver Name </p>
            <p
              class="subject-data">{{ record?.insuranceDetails?.thirdPartyDriverName ? record?.insuranceDetails?.thirdPartyDriverName : '-' }}</p>
          </div>
          <div class="item-row">
            <p class="subject-name">Third Party Driver Contact Number </p>
            <p class="subject-data" *ngIf="record?.insuranceDetails?.thirdPartyDriverContactNo">
              <a class="clickable-mail-phone_no"
                 href="tel:{{record?.insuranceDetails?.thirdPartyDriverContactNo}}">{{ record?.insuranceDetails?.thirdPartyDriverContactNo }}</a>
            </p>
            <p *ngIf="!record?.insuranceDetails?.thirdPartyDriverContactNo" class="subject-data">-</p>
          </div>
          <div class="item-row">
            <p class="subject-name">Third Party Insurance Number </p>
            <p
              class="subject-data">{{ record?.insuranceDetails?.thirdPartyInsuranceNo ? record?.insuranceDetails?.thirdPartyInsuranceNo : '-' }}</p>
          </div>
          <div class="item-row">
            <p class="subject-name">Third Party Insurance Expiry Date </p>
            <p
              class="subject-data">{{ record?.insuranceDetails?.thirdPartyInsuranceExpiryDate ? (record?.insuranceDetails?.thirdPartyInsuranceExpiryDate | date: 'dd-MM-y') : '-' }}</p>
          </div>
        </div>
      </div>
    </nz-card>
  </section>

  <section id="driverDetails">
    <nz-card class="mt-5">
      <h5 class="mb-3">Driver Details</h5>
      <div class="grid gap-x-4 md:gap-x-16 xl:grid-cols-2">
        <div class="sub-section ">
          <div class="item-row">
            <p class="subject-name">Driver Name </p>
            <p class="subject-data">{{ record?.driverDetails?.driverName }}</p>
          </div>
          <div class="item-row">
            <p class="subject-name">Driver's Contact Number </p>
            <p class="subject-data"><a class="clickable-mail-phone_no"
                                       href="{{record?.driverDetails?.driverContactNo}}">{{ record?.driverDetails?.driverContactNo }}</a>
            </p>
          </div>
        </div>
        <div class="sub-section">
          <div class="item-row">
            <p class="subject-name">Driver'S Address </p>
            <p class="subject-data">{{ record?.driverDetails?.driverAddress }}</p>
          </div>
        </div>
      </div>
    </nz-card>
  </section>

  <section id="accidentDetails">
    <nz-card class="mt-6">
      <h5 class="mb-3">Accident Details</h5>
      <div class="grid gap-x-4 md:gap-x-16 xl:grid-cols-2">
        <div class="sub-section ">
          <div class="item-row">
            <p class="subject-name">Accident Date and Time </p>
            <p
              class="subject-data">{{ record?.accidentDetails?.accidentDateAndTime | date: "dd-MM-y | hh:mm aa" }}</p>
          </div>
          <div class="item-row">
            <p class="subject-name">Place of the Accident </p>
            <p class="subject-data">{{ record?.accidentDetails?.placeOfTheAccident }}</p>
          </div>
          <div class="item-row">
            <p class="subject-name">Accident - Notified or Detected </p>
            <p *ngIf="record?.accidentDetails?.notified" class="subject-data">Notified</p>
            <p *ngIf="record?.accidentDetails?.detected" class="subject-data">Detected</p>
          </div>
          <div class="item-row">
            <p *ngIf="record?.accidentDetails?.notified" class="subject-name">Notified SR
              User </p>
            <p *ngIf="record?.accidentDetails?.detected" class="subject-name">Detected SR
              User </p>
            <p class="subject-data">{{ record?.notifiedOrDetectedUserName }}</p>
          </div>
        </div>

        <div class="sub-section lg:mb-10">
          <div class="item-row">
            <p class="subject-name">Insurance Notified </p>
            <p
              class="subject-data">{{ (record?.accidentDetails?.insuranceNotified === 'ON_SITE') ? 'On Site' : 'On Departure' }}</p>
          </div>
          <div class="item-row">
            <p class="subject-name">Need to notify to the Insurance </p>
            <p class="subject-data">{{ record?.accidentDetails?.needToNotifyTheInsurance ? 'Yes' : 'No' }}</p>
          </div>
          <div class="item-row">
            <p class="subject-name">Police Report Obtained </p>
            <p class="subject-data">{{ record?.accidentDetails?.policeReportObtained ? 'Yes' : 'No' }}</p>
          </div>
        </div>

        <div class="sub-section lg:mb-10">
          <div class="flex-row">
            <p class="subject-name">Remarks </p>
            <!--              <p class="font-medium">{{record?.accidentDetails?.remarks}}</p>-->
            <p class="subject-data text-justify">{{ record?.accidentDetails?.remarks }}</p>
            <!--              <p class="font-normal" style="color: #6d6d6d">Need to notify to the Insurance </p>-->
            <!--              <p class="font-medium">{{record?.accidentDetails?.needToNotifyTheInsurance ? 'Yes' : 'No'}}</p>-->
          </div>
        </div>

        <div class="sub-section lg:mb-10">
          <div class="item-row">
            <p class="subject-name">Attachments</p>
            <div class="flex flex-col mt-2">
              <a *ngFor="let file of record?.accidentDetails?.attachments" href="{{file.url}}"
                 [nz-tooltip]="file.name"
                 target="_blank"><span nz-icon nzType="file" class="text-sm"
                                       nzTheme="outline"></span><span
                class="ml-2 text-sm text-black"> - {{ file.name }}</span></a>
            </div>
            <!--              <p class="font-normal" style="color: #6d6d6d">Attachments</p>-->
          </div>
          <div>
            <!--              <div class="flex flex-col mt-2">-->
            <!--                <a *ngFor="let file of record?.accidentDetails?.attachments" href="{{file.url}}" [nz-tooltip]="file.name"-->
            <!--                   target="_blank"><span nz-icon nzType="file"-->
            <!--                                         nzTheme="outline"></span><span-->
            <!--                  class="text-black ml-2">{{file.name}}</span></a>-->
            <!--              </div>-->
          </div>
        </div>

        <div class="sub-section">
          <div class="item-row">
            <p class="subject-name">Deposit Amount </p>
            <p class="subject-data">{{ record?.paymentDetails?.depositAmount | currency: 'symbol': 'LKR' }}</p>
          </div>
          <div class="item-row">
            <p class="subject-name">Damage Charge </p>
            <p class="subject-data">{{ record?.paymentDetails?.damageCharge | currency: 'symbol': 'LKR' }}</p>
          </div>
          <div class="item-row">
            <p class="subject-name">Loss of Rental Charge</p>
            <p class="subject-data">{{ record?.paymentDetails?.lossOfRentalCharge | currency: 'symbol': 'LKR' }}</p>
          </div>
          <div class="item-row">
            <p class="subject-name topic-text">Total Charge</p>
            <p class="subject-data topic-text">{{ record?.paymentDetails?.totalCharge | currency: 'symbol': 'LKR' }}</p>
          </div>
        </div>
      </div>
    </nz-card>
  </section>

  <section id="damages" class="mt-6">
    <nz-card>
      <div>
        <h5 class="text-primary">Damages</h5>
        <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-2 gap-8">
          <div>
            <div class="xl:col-span-2  pb-3">
              <nz-alert nzType="info" style="display: inline-block;"
                        nzMessage="Select the damaged area on the image below to add a new record"
                        class="mb-3 custom-alert w-full" nzShowIcon></nz-alert>
            </div>
            <!--            <p class="font-medium text-sm mb-8">Select the damaged area on the image below to add a new record</p>-->

            <div class="image-container">
              <img style="max-width: 100%;height: auto;" src="assets/img/car-damage.png" alt="Image" #image>
              <div *ngFor="let marker of this.record?.damages">
                <div *ngIf="marker?.status !== false" class="marker"
                     [style.left.%]="marker.x" [style.top.%]="marker.y">
                  {{ marker.number }}
                </div>
                <div style="background-color: green" *ngIf="marker.status === false" class="marker"
                     [style.left.%]="marker.x" [style.top.%]="marker.y">
                  {{ marker.number }}
                </div>
              </div>
            </div>
          </div>

          <div class="sub-section">


            <nz-collapse>
              <nz-collapse-panel
                *ngFor="let panel of this.record?.damages; let i = index"
                [nzHeader]='panelHead'
                style="background-color: white; border: 2px solid #d9d9d9;" class="font-medium"
              >

                <div class="damage-card mb-3 my-2 flex flex-col sm:flex-row">


                  <div class="w-full p-5">
                    <div class="pl-0 sm:pl-2">
                      <div class="item-row flex mb-2">
                        <div>
                          <p style="font-weight: 400; color: #6d6d6d">Damage Type: </p>
                          <p class="subject-data">{{ panel.damageType }}</p>
                        </div>
                        <div class="flex-grow">

                        </div>
                        <div class="badge-Id">
                          <span class="badge-number" *ngIf="panel.damageType === 'Scratch'">1</span>
                          <span class="badge-number" *ngIf="panel.damageType === 'Dent'">2</span>
                          <span class="badge-number" *ngIf="panel.damageType === 'Broken'">3</span>
                          <span class="badge-number" *ngIf="panel.damageType === 'Cracked'">4</span>
                          <span class="badge-number" *ngIf="panel.damageType === 'Missing'">5</span>
                          <span class="badge-number" *ngIf="panel.damageType === 'Stain'">6</span>
                          <span class="badge-number" *ngIf="panel.damageType === 'Smashed'">7</span>
                        </div>
                      </div>

                      <div class="mb-2">
                        <p class="subject-name">Description: </p>
                        <p class="subject-data">{{ panel.description }}</p>
                      </div>
                      <div class="mb-2">
                        <p class="subject-name">Attachments: </p>
                        <div class="mt-3 flex" style="flex-wrap: wrap;">
                          <img *ngFor="let attachment of panel.files" style="margin-left: 3px; margin-bottom: 3px"
                               [src]="attachment.url" class="min-[400px]:hidden"
                               height="80" width="140" alt="Image">
                          <img *ngFor="let attachment of panel.files" style="margin-left: 3px; margin-bottom: 3px"
                               [src]="attachment.url" class="hidden min-[400px]:block"
                               height="80" width="160" alt="Image">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="">
                  <nz-divider></nz-divider>
                </div>

                <ng-template #panelHead>
                  <div class="flex" style="margin-right: 20px">
                    <div class="badge" *ngIf="panel?.status !== false">
                      <span class="badge-number">{{ panel.number }}</span>
                    </div>
                    <div class="badge" style="background-color: green" *ngIf="panel.status === false">
                      <span class="badge-number">{{ panel.number }}</span>
                    </div>
                  </div>
                  <p class="font-semibold">{{ panel.damageType }}</p>
                  <div class="flex-grow"></div><!-- This div will push the button to the right -->

                  <div class="gap-2">
                    <!--                    <button-->
                    <!--                      class="outline-button"-->
                    <!--                      nz-button-->
                    <!--                      (click)="editDamage(panel, i)"-->
                    <!--                    >-->
                    <!--                      <span nz-icon nzType="edit" nzTheme="outline"></span>-->
                    <!--                    </button>-->
                    <!--                    <button-->
                    <!--                      class="outline-button more-dropdown"-->
                    <!--                      nz-button-->
                    <!--                      nzDanger nz-popconfirm-->
                    <!--                      nzPopconfirmTitle="Are you sure you want to delete the Damage Record"-->
                    <!--                      nzPopconfirmPlacement="bottom"-->
                    <!--                      (nzOnConfirm)="deleteDamage(i)"-->
                    <!--                      (nzOnCancel)="cancel()"-->
                    <!--                      (click)="$event.stopPropagation()"-->
                    <!--                    >-->
                    <!--                      <span nz-icon nzType="delete" nzTheme="outline"></span>-->
                    <!--                    </button>-->
                  </div>
                </ng-template>
              </nz-collapse-panel>
            </nz-collapse>
          </div>

        </div>
      </div>
    </nz-card>
  </section>

  <section id="damageTable" class="mt-6">
    <nz-card>
      <div>
        <h5 class="mb-3">Damages</h5>
        <div class="w-full">
          <nz-divider></nz-divider>
        </div>
        <nz-table #filterTable [nzData]="record?.damages"
                  [nzFrontPagination]="false"
                  [nzScroll]="{ x: 'auto' }"
                  nzTableLayout="fixed"
                  class="table-wSpace-nowrap">
          <thead>
          <tr>
            <th>Damage Id</th>
            <th>Damage Type</th>
            <th>Date and Time</th>
            <th>Description</th>
            <th>Attachments</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let data of filterTable.data; index as i">
            <td class="nonWrap">{{ getDamageId(i) }}</td>
            <td class="nonWrap">{{ data?.damageType | titlecase }}</td>
            <td class="nonWrap">{{ record?.accidentDetails?.accidentDateAndTime | date : "dd-MM-y | hh:mm aa" }}</td>
            <td>{{ data?.description }}</td>
            <td class="nonWrap">
              <div *ngFor="let file of data?.files" class="flex">
                <a href="{{file.url}}" target="_blank">
                  <span nz-icon nzType="file" nzTheme="outline" class="text-primary text-xs"></span>
                  <span class="text-black text-xs"> - {{ file.name }}</span>
                </a>
              </div>
            </td>
          </tr>
          </tbody>
        </nz-table>

        <!--        <div class="grid grid-cols-5">-->
        <!--          <div>-->
        <!--            <h6>Damage Id</h6>-->
        <!--          </div>-->
        <!--          <div>-->
        <!--            <h6>Damage Type</h6>-->
        <!--          </div>-->
        <!--          <div>-->
        <!--            <h6>Date and Time</h6>-->
        <!--          </div>-->
        <!--          <div>-->
        <!--            <h6>Description</h6>-->
        <!--          </div>-->
        <!--          <div>-->
        <!--            <h6>Attachments</h6>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <div class="w-full">-->
        <!--          <nz-divider></nz-divider>-->
        <!--        </div>-->
        <!--        <div *ngFor="let damage of record?.damages; index as i">-->
        <!--          <div class="grid grid-cols-5">-->
        <!--            <div>-->
        <!--              <p>{{getDamageId(i)}}</p>-->
        <!--            </div>-->
        <!--            <div>-->
        <!--              <p>{{damage.type | titlecase}}</p>-->
        <!--            </div>-->
        <!--            <div>-->
        <!--              <p>{{record?.accidentDetails?.accidentDateAndTime | date : "dd-MM-y | hh:mm aa" }}</p>-->
        <!--            </div>-->
        <!--            <div>-->
        <!--              <p>{{damage.description}}</p>-->
        <!--            </div>-->
        <!--            <div>-->
        <!--              <div *ngFor="let file of damage?.attachments" class="flex">-->
        <!--                <a href="{{file.url}}" target="_blank">-->
        <!--                  <span nz-icon nzType="file" nzTheme="outline" class="text-primary text-xs"></span>-->
        <!--                  <span class="text-black text-xs"> - {{file.name}}</span>-->
        <!--                </a>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <div class="w-full">-->
        <!--            <nz-divider></nz-divider>-->
        <!--          </div>-->
        <!--        </div>-->

      </div>
    </nz-card>
  </section>

  <section id="description" class="">
    <nz-card class="mt-6">
      <div class="grid">
        <div>
          <!--        <h5 class="mb-3">&nbsp;</h5>-->
          <div class="sub-section">
            <div class="grid grid-cols-2 gap-auto">
              <div>
                <p class="font-normal" style="color: #6d6d6d">Description </p>
              </div>
              <div>
                <!--              <p class="font-medium">{{record?.driverDetails?.driverName}}</p>-->
              </div>
            </div>
            <div class="grid grid-cols-1 gap-auto">
              <div>
                <p class="font-medium text-justify">{{ record?.description }}</p>
                <!--              <p class="font-normal" style="color: #6d6d6d">Driver's Contact Number </p>-->
              </div>
              <div>
                <!--              <p class="font-medium">{{record?.driverDetails?.driverContactNo}}</p>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </nz-card>
  </section>

</div>

<nz-modal
  [(nzVisible)]="isVisibleEditDescription"
  nzTitle="Generate Report"
  (nzOnCancel)="handleCancelEditDescription()"
  (nzOnOk)="handleOkEditDescription()">
  <ng-container *nzModalContent>
    <p class="mb-1 subject-data">Edit Description</p>
    <textarea rows="5" nz-input [(ngModel)]="editableDescription"></textarea>
    <div class="flex justify-end my-2">
      <button nz-button nzType="primary"
              nz-popconfirm
              nzPopconfirmTitle="Are you sure want to update damage description?"
              nzOkText="Ok"
              nzCancelText="Cancel"
              (nzOnConfirm)="handleOkEditDescription()"
              (nzOnCancel)="handleCancel()" [disabled]="editableDescription === record?.description">Save
      </button>
    </div>
  </ng-container>
  <div *nzModalFooter class="flex justify-between">
    <button *appHasAnyPrivilege="'REPORT_GENERATE'" nz-button nzType="primary" (click)="generateReport()"
            [disabled]="editableDescription !== record?.description || isPdfGenerated" [nzLoading]="generating">Generate
    </button>
    <div>
      <button *appHasAnyPrivilege="'REPORT_PREVIEW'" nz-button nzType="default" (click)="previewReport()"
              [disabled]="editableDescription !== record?.description || !isPdfGenerated">Preview
      </button>
      <button *appHasAnyPrivilege="'REPORT_PRINT'" nz-button nzType="default" (click)="printReport()"
              [disabled]="editableDescription !== record?.description || !isPdfGenerated">Print
      </button>
      <button *appHasAnyPrivilege="'REPORT_EMAIL'" nz-button nzType="default"
              [disabled]="editableDescription !== record?.description || !isPdfGenerated" (click)="emailPdf()">
        Send
      </button>
      <button *appHasAnyPrivilege="'REPORT_DOWNLOAD'" nz-button nzType="default" (click)="downloadReport()"
              [disabled]="editableDescription !== record?.description || !isPdfGenerated" [nzLoading]="downloading">
        Download
      </button>
    </div>
  </div>
</nz-modal>

<div [ngClass]="loading ? 'block' : 'hidden'">
  <app-single-view-skeleton-template [typeName]="'single-view'"></app-single-view-skeleton-template>
</div>
